import { render, staticRenderFns } from "./base-html-editor.vue?vue&type=template&id=ba9dc5c4&"
import script from "./base-html-editor.vue?vue&type=script&lang=js&"
export * from "./base-html-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports